import React, { memo, useCallback } from 'react';
import { createSelector } from 'reselect';
import styles from './Empty.module.less';
import DEFAULT from '../../../static/wp/wp_invalid.png';
import { useDispatch, useSelector } from 'react-redux';
import { updateShowWpOrder } from '../../../actions/wallpaper';
import { getVipState } from '../../../actions/wallpaperPay';

const SelectVipState = createSelector(
  state => state.wallpaperPay,
  wallpaperPay => wallpaperPay.vipState,
);

export default memo(() => {
  const dispatch = useDispatch();
  const vipState = useSelector(SelectVipState);

  const callbackOrder = useCallback(
    flag => {
      if (flag) {
        dispatch(getVipState());
      }
    },
    [vipState],
  );

  const handleOpenVip = () => {
    dispatch(
      updateShowWpOrder({
        show: true,
        wallpaperId: '',
        code: '',
        wpType: 3, // 1: 单张壁纸，2：壁纸包 3: 仅仅订阅
        callbackTurnOrder: callbackOrder,
      }),
    );
  };

  return (
    <div className={styles.empty}>
      <div className="info">
        <div className="info info_img">
          <img src={DEFAULT} />
        </div>
        <div className="info info_text">
          <span>抱歉，你的权益已过期</span>
          <span className="info info_text text_open" onClick={handleOpenVip}>
            立即开通权益{' '}
          </span>
        </div>
      </div>
    </div>
  );
});
